export { DialogModal } from './DialogModal';
export type { DialogModalClassNames, DialogModalProps } from './DialogModal';
